import * as learningConfig from './learningCase';
import * as carshowConfig from './carShow';
import * as industryConfig from './industrySummit';
import * as artShowConfig from './artShow';

type EnumKeysExceptExcluded<T extends string, E> = {
  [K in T]: K extends E ? never : K;
}[T];

export enum EnumCaseTypes {
  Learning = 'learning',
  CarShow = 'carShow',
  IndustrySummit = 'industrySummit',
  ArtShow = 'artShow',
  CorporateSpace = 'corporate-space',
  Museum = 'museum',
}

export type CaseTypes = EnumKeysExceptExcluded<EnumCaseTypes, EnumCaseTypes.CorporateSpace | EnumCaseTypes.Museum>;

export const CARD_BG: { [key in CaseTypes]: string } = {
  learning: learningConfig.CARD_BG,
  carShow: carshowConfig.CARD_BG,
  industrySummit: industryConfig.CARD_BG,
  artShow: artShowConfig.CARD_BG,
};
export const CARD_TEXT = {
  learning: learningConfig.CARD_TEXT,
  carShow: carshowConfig.CARD_TEXT,
  industrySummit: industryConfig.CARD_TEXT,
  artShow: artShowConfig.CARD_TEXT,
};
export const DEMANDS = {
  learning: learningConfig.DEMANDS,
  carShow: carshowConfig.DEMANDS,
  industrySummit: industryConfig.DEMANDS,
  artShow: artShowConfig.DEMANDS,
};
export const FEATURES = {
  learning: learningConfig.FEATURES,
  carShow: carshowConfig.FEATURES,
  industrySummit: industryConfig.FEATURES,
  artShow: artShowConfig.FEATURES,
};
export const ADVANTAGES = {
  learning: learningConfig.L_ADVANTAGES,
  carShow: carshowConfig.ADVANTAGES,
  industrySummit: industryConfig.ADVANTAGES,
  artShow: artShowConfig.ADVANTAGES,
};
export const SUCCESS_CASES = {
  learning: learningConfig.L_SUCCESS_CASES,
  carShow: [],
  industrySummit: industryConfig.SUCCESS_CASES,
  artShow: artShowConfig.SUCCESS_CASES,
};

export interface ComponentProps {
  type: CaseTypes;
  title: string[];
  subtitle?: string;
}

export interface CardItem {
  title: string;
  brief_intro: string;
  url: string;
  type: string;
  [key: string]: any;
}

export const SCENE_LIST: CardItem[] = [
  {
    id: 'learning',
    type: 'meeting',
    title: '学术会议',
    brief_intro: '专家学者虚拟畅聊，参会者线上社交，交流研究动向，高品质的线上沉浸式学术会议',
    url: 'https://static.fuxi.netease.com/yaotai/portal/20220901/l7itjmcj_937827.png',
  },
  {
    id: 'industrySummit',
    type: 'meeting',
    title: '行业峰会',
    brief_intro: '融合场景定制、会议组织、线上社交等功能的一站式行业峰会场景方案，等你体验。',
    url: 'https://static.fuxi.netease.com/yaotai/portal/20220901/l7itjmcl_937829.png',
  },
  {
    id: 'carShow',
    title: '车展展览',
    type: 'virtual',
    brief_intro:
      '酷炫汽车一比一复刻进虚拟场景，汽车爱好者足不出户沉浸看展，行业人员在线高效交流，未来感十足的在线车展。',
    url: 'https://static.fuxi.netease.com/yaotai/portal/20220901/l7itjmcp_937833.png',
  },
  {
    id: 'artShow',
    type: 'virtual',
    title: '艺术展厅',
    brief_intro: '提供专属画廊展厅定制、藏品陈列、作品讲解等多功能于一体的瑶台在线艺术展，期待你的到来。',
    url: 'https://static.fuxi.netease.com/yaotai/portal/20220901/l7itjmcq_937834.png',
  },
  {
    id: 'corporate-space',
    type: 'corporate',
    title: '企业元空间',
    brief_intro: '定制化企业门户，打通平面企业官网与3D虚拟场景的壁垒，一站式解决您的所有需求。',
    url: 'https://static.fuxi.netease.com/yaotai/portal/index/lm75yugn_944503.png',
  },
  {
    id: 'museum',
    type: 'tourism',
    title: '博物馆',
    brief_intro: '全方位展品陈列，一键点击即可穿越时空，感受古今文明的碰撞与交流。',
    url: 'https://static.fuxi.netease.com/yaotai/portal/index/lm75p8af_495862.png',
  },
];

const tabFac = (code: string, name: string) => ({ key: code, label: name });
export const SCENE_TABS = [
  tabFac('all', '全部'),
  tabFac('meeting', '会议活动'),
  tabFac('virtual', '虚拟展会'),
  tabFac('corporate', '企业门户'),
  tabFac('tourism', '文旅场景'),
];

export * from './learningCase';
export * from './museum';
